import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';
import { Formik } from 'formik';
import HSCodeForm from '~/components/hsCodeForm/hsCodeForm';
import { hsCodeValidationSchema } from '../../validation/hsCode';

export const createHSCodeMutation = gql`
  mutation createHSCode($breweryId: Int!, $name: String!, $description: String) {
    createHSCode(breweryId: $breweryId, name: $name, description: $description) {
      id
      name
      breweryId
      description
    }
  }
`;

export const HSCodeCreateForm = ({ brewery, history, client }) => (
  <div className="content">
    <Mutation mutation={createHSCodeMutation}>
      {(hsCodeCreate, { error }) => (
        <Formik
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={hsCodeValidationSchema}
          onSubmit={async (values, { setErrors, setSubmitting }) => {
            try {
              const newCode = await hsCodeCreate({
                variables: {
                  ...values,
                  breweryId: brewery.id
                },
                refetchQueries: ['hsCodes']
              });
              history.push(`/settings/hscodes?new=${newCode.data.createHSCode.name}`);
            } catch (err) {
              setErrors({
                unknown: 'An unknown error occured'
              });
              setSubmitting(false);
            }
          }}
          render={HSCodeForm}
        />
      )}
    </Mutation>
  </div>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(withApollo(HSCodeCreateForm)));



// WEBPACK FOOTER //
// ./src/containers/hsCodeCreate/hsCodeCreate.jsx